// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content[data-v-25b7d1e6]{padding-top:72px;padding-bottom:141px}.content .contact-info[data-v-25b7d1e6]{display:flex;justify-content:space-between;font-size:18px;color:#333;padding:0px 96px;margin-top:62px}.content .contact-info img[data-v-25b7d1e6]{width:18px;height:18px;vertical-align:middle}.bdwindow[data-v-25b7d1e6]{height:442px;width:1118px;margin:0 auto;margin-top:44px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
